import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/(commerce)/kayit-ol/page.tsx");
